import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=5a0d0f57&scoped=true"
import script from "./expert.vue?vue&type=script&lang=js"
export * from "./expert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d0f57",
  null
  
)

export default component.exports